import React, { CSSProperties, useEffect } from 'react';

import { ASComponentSize, ComponentSize } from '@eleventheye/asui';
import ButtonGroup, { ButtonGroupItem, ButtonGroupProps } from '../ButtonGroup';

type TitledButtonGroupProps = {
  title: string;
  buttonItems: string[];
  itemSize?: ASComponentSize;
  selectedItem?: string;
  onItemSelected?: (item: string) => void;
  disabledItems?: string[];
  useUpperCase?: boolean;
  style?: CSSProperties;
} & ButtonGroupProps;

const TitledButtonGroup: React.FC<TitledButtonGroupProps> = ({
  disabledItems = [],
  useUpperCase = false,
  onItemSelected,
  style,
  ...props
}) => {
  const items = [props.title, ...props.buttonItems];

  const [selected, setSelected] = React.useState<string>('');

  useEffect(() => {
    if (selected !== props.selectedItem) setSelected(props.selectedItem ?? '');
  }, [props.selectedItem]);

  const isDisabled = (item: string) => disabledItems.includes(item) || props.title === item;
  const isSelected = (item: string) => selected === item || props.title === item;

  const onClick = (item: string) => {
    if (!isDisabled(item)) setSelected(item);
    if (onItemSelected) onItemSelected(item);
  };

  return (
    <ButtonGroup className={props.className ?? ''} style={style}>
      {items.map((item) => (
        <ButtonGroupItem
          key={`k_${item}`}
          className={'TitledItem'}
          useUpperCase={useUpperCase}
          disabled={isDisabled(item)}
          size={props.itemSize ?? ComponentSize.Medium}
          selected={isSelected(item)}
          onClick={() => onClick(item)}
        >
          {item}
        </ButtonGroupItem>
      ))}
    </ButtonGroup>
  );
};

export default TitledButtonGroup;
